export default __webpack_public_path__ + "0c5acd672a852a165fdfdbabe8aaad39.svg";